// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LeapSortableController from "./leap_sortable_controller"
application.register("sortable", LeapSortableController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import NewMenuItemController from "./new_menu_item_controller"
application.register("new-menu-item", NewMenuItemController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import VideoController from "./video_controller"
application.register("video", VideoController)

import PdfSlideshowController from "./pdf_slideshow_controller"
application.register("pdf-slideshow", PdfSlideshowController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import "./railsui"
